<template>
  <main class="w-full mb-5 flex" :class="left ? '' : 'd-flex flex-row-reverse'">
    <div v-if="message.sender === undefined && message.tag !== 'chat.newDate'" :class="'message-system'" class="message message-system" style="word-wrap: break-word; text-align: center">
      <v-expansion-panels v-if="message.sender === undefined" accordion flat>
        <v-expansion-panel style="background-color:  #6C6C6C;padding: 0">
          <v-expansion-panel-header class="message message-system2" style="text-align: center;padding:0px; min-height: auto" @click="onExpansionPanelClick">
            <div style="word-break: break-word">
              {{ plainMessage }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="message-system2" style="margin-top: 10px;padding: 0">
            <div style="margin-bottom: 10px;text-align: left">
              {{ messageSystemExtra }}
            </div>
            <iframe v-if="videoUrl" :id="message._id" style="max-width: 280px" :src="videoUrl+autplay" allow="autoplay" frameborder="0" allowfullscreen />
            <div v-if="link">
              <a :href="link" target="_blank">
                {{ descriptionLink }}
              </a>
            </div>
            <div v-if="admin && message.tag">
              {{ message.tag }}
            </div>
            <div style="text-align: center">
              {{ messageHour }}
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div v-else-if="message.tag === 'chat.newDate'" :class="'message-system'" class="message message-system" style="word-wrap: break-word; text-align: center">
      <div style="word-break: break-word">
        {{ messageDate }}
      </div>
    </div>
    <div v-else-if="message.idFile === undefined" :class="left ? 'message-in' : 'message-out'" class="message px-4  grow " style="word-wrap: break-word">
      <b>{{ username }}</b><v-spacer />
      {{ message.text }}
      <div class="d-flex flex-row-reverse">
        {{ messageHour }}
      </div>
    </div>
    <div v-else :class="left ? 'message-in-image' : 'message-out-image'">
      <div style="margin-top: 5px; margin-left: 10px;">
        <strong>{{ username }}</strong><v-spacer />
      </div>
      <a :href="'/api/uploads/' + image" target="_blank" :download="image[0] === '[' ? image.slice(26, image.length) : image">
        <img v-if="image && !image.toLowerCase().endsWith('.pdf')" alt="image" style="max-width: 90%; min-width: 50%;min-height: 50%;max-height: 250px; margin: 10px" :src="'/api/uploads/' + image">
        <div v-if="image && image.toLowerCase().endsWith('.pdf')">
          <pdf :src="'/api/uploads/' + image" align="center" style="max-width: 100%; min-width:50%; min-height: 25%; max-height: 50%; margin: 10px" />
        </div>
      </a>
      <div class="d-flex flex-row-reverse" style="margin-right: 10px">
        {{ messageHour }}
      </div>
    </div>
  </main>
</template>

<script>

import {User} from "../models/user";
import pdf from "vue-pdf";
import Constants from "../../constants";
import moment from "moment";

export default {
    name: "ItemMessage",
    components: {pdf},
    props: {
        left: {
            type: Boolean, //Decideix si aquest missatge va col·locat a la dreta o l'esquerra depenent de l'enviador
            default: true
        },
        message: {
            type: Object, //missatge corresponent
            default: null
        },
    },
    data () {
        return {
            username: '',
            messageHour: this.message.created[11] + this.message.created[12] + ':' + this.message.created[14] + this.message.created[15],
            JSON: JSON,
            image: '',
            messageSystem: '',
            messageSystemExtra: null,
            videoUrl: '',
            dialog: false,
            link: '',
            descriptionLink: '',
            plainMessage: '',
            autplay: '',
            admin: false,
            messageDate: ''
        };
    },
    created () {
        this.admin = this.$user.role === Constants.USER.ROLE_ADMIN;
        this.fetch();
    },
    methods: {
        onExpansionPanelClick (event) {
            const frame = document.getElementById(this.message._id);
            if (frame) {
                if (event.currentTarget.classList.contains('v-expansion-panel-header--active')) {
                    //console.log("Panel is closing/now closed.");
                    frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                } else {
                    //console.log("Panel is opening/now open.");
                    frame.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                }
            }
           
        },
        fetch () {
            this.messageHour = moment(this.message.created).format("LT");
            this.messageDate =  moment(this.message.created).format("l");
            this.username = (new User(this.message.sender)).getSingleName();
            if (this.message.idFile) {
                this.image = this.message.idFile.originalName;
            }

            const messageObject = this.toJson(this.message.text);
            if (messageObject) {
                for (const k in messageObject.params) {
                    if (messageObject.params[k]) {
                        const name = messageObject.params[k].toString();
                        messageObject.params[k] = name.toUpperCase();
                    }
                }
                this.messageSystemExtra = this.$t(messageObject.extraMessage, messageObject.params);
                const map = new Map(this.message.extra.map(i => [i.subTag, i.value]));
                if (map.has('videoUrl')) {
                    this.videoUrl = map.get('videoUrl');
                    const split = this.videoUrl.split('/');
                    this.autplay = '?version=3&autoplay=1&loop=1&playlist=' + split[split.length - 1] + "&enablejsapi=1";
                }
                if (map.has('link')) this.link = map.get('link');
                if (map.has('descriptionLink')) this.descriptionLink = map.get('descriptionLink');
                this.plainMessage = this.$t(messageObject.message, messageObject.params);
            }
        },
        toJson (str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                return false;
            }
        },
        getName (email = false) {
            let name = "";
            if (this.message.idUser) {
                if (this.message.idUser.name) name = this.message.idUser.name;
                if (this.message.idUser.surname) {
                    if (name.length > 0) name += " ";
                    name += this.message.idUser.surname;
                }
                if (this.message.idUser.cif && !this.message.idUser.name) {
                    name = this.message.idUser.cif;
                }
                if (email && this.message.idUser.email) {
                    if (name.length === 0) {
                        name = this.message.idUser.email;
                    }
                }
            }
            return name.toUpperCase();
        }
    }
};
</script>

<style scoped>
.message {
    margin-top: 15px;
    max-width: 330px;
    padding: .5em;
    margin-bottom: .5em;
    font-size: .8em;
}
.message-out {
    background: #407FFF;
    color: white;
    margin-left: 50%;
    margin-right: 5%;
    border-radius: 15px 0 15px 15px ;
}
.message-in {
    background: #F1F0F0;
    color: black;
    margin-left: 5%;
    margin-right: 50%;
    border-radius: 0 15px 15px ;
}
.message-out-image {
    background: #407FFF;
    color: white;
    margin-left: 50%;
    margin-right: 5%;
    border-radius: 10px 0 20px 20px ;
    font-size: .8em;
}
.message-in-image {
    background: #F1F0F0;
    color: black;
    margin-left: 5%;
    margin-right: 50%;
    border-radius: 0 10px 20px 20px ;
    font-size: .8em;
}

.message-system {
    background: #6C6C6C;
    color: white;
    margin: auto;
    border-radius: 1vw;
    font-size: .7em;
}

.message-system2 {
    background: #6C6C6C;
    color: white;
    border-radius: 1vw;
    font-size: 13px;
    margin: 0;
    text-align: center;
    padding: 0;
}
.v-expansion-panel-content__wrap {
    padding: 0;
}

</style>
